"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.placeNeighbourhood = void 0;
var React = require("react");
var classnames_1 = require("classnames");
var NeighbourhoodInfo_1 = require("@/pages/place/states/NeighbourhoodInfo");
var NeighbourhoodSaga_1 = require("@/pages/place/sagas/NeighbourhoodSaga");
exports.placeNeighbourhood = function (props) {
    if (!props.lat || !props.lng)
        return null;
    var bgStyle = {
        // tslint:disable-next-line:max-line-length
        background: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAEElEQVQImWNgoAN49+7dfwAJxgPKE2sz6wAAAABJRU5ErkJggg==) repeat',
    };
    var renderSubitem = function (item, k) {
        var onSubitemClick = function (m) { return function () { return props.onSubitemClick(m, item.point); }; };
        return (React.createElement("div", { key: k, onClick: onSubitemClick(k), className: "c-neighbourhood__gitem c-neighbourhood__gitem--sub" }, item.name));
    };
    var renderItem = function (item, i) {
        var setNearbyType = function (type) { return function () {
            props.setNearbyType(type);
        }; };
        var markerClass = classnames_1.default(['c-marker', 'c-marker--inline', "c-marker--" + NeighbourhoodSaga_1.getIconString(item.type), {
                'c-marker--active': item.type === props.neighbourhood.activeType,
            }]);
        var itemClass = classnames_1.default([
            'c-neighbourhood__gitem',
            {
                'c-neighbourhood__gitem--active': item.type === props.neighbourhood.activeType,
            },
        ]);
        var renderAddPlace = function (props) {
            var addPlaceUrl = "/" + props.lang + "/profile/addplace";
            var addThisPlaceDiv = (React.createElement("a", { onClick: props.addPlaceClick, className: "c-neighbourhood__gitem c-neighbourhood__gitem--sub" },
                React.createElement("div", { className: "o-textbtn" },
                    React.createElement("span", { className: "fa fa-plus" }),
                    props.t.addThisPlace)));
            var addThisLocationDiv = (React.createElement("a", { href: addPlaceUrl, className: "c-neighbourhood__gitem c-neighbourhood__gitem--sub" },
                React.createElement("div", { className: "o-textbtn" },
                    React.createElement("span", { className: "fa fa-plus" }),
                    props.t.addOtherPlace)));
            return (React.createElement(React.Fragment, null,
                props.neighbourhood.addPlaceActive && props.address ? addThisPlaceDiv : null,
                addThisLocationDiv));
        };
        var itemElm = (React.createElement("div", { onClick: setNearbyType(item.type), key: i, className: itemClass },
            React.createElement("span", { className: markerClass }),
            "\u00A0\u00A0",
            item.name));
        if (item.type === NeighbourhoodInfo_1.NeighbourhoodItemType.PIN && !props.isGuest) {
            var groupClass = classnames_1.default([
                'c-neighbourhood__gitem-group',
                {
                    'c-neighbourhood__gitem-group--active': item.type === props.neighbourhood.activeType,
                },
            ]);
            return (React.createElement("div", { className: groupClass, key: i },
                itemElm,
                item.children ? item.children.map(renderSubitem) : '',
                renderAddPlace(props)));
        }
        if (item.children && item.children.length) {
            var groupClass = classnames_1.default([
                'c-neighbourhood__gitem-group',
                {
                    'c-neighbourhood__gitem-group--active': item.type === props.neighbourhood.activeType,
                },
            ]);
            return (React.createElement("div", { className: groupClass, key: i },
                itemElm,
                item.children.map(renderSubitem)));
        }
        return itemElm;
    };
    var renderGroup = function (group, i, active) {
        var groupClass = classnames_1.default([
            'c-neighbourhood__group',
            {
                'c-neighbourhood__group--active': active === i,
            },
        ]);
        var setActive = function (i) { return function () {
            props.toggleNeighbourhoodGroupActive(i);
        }; };
        return (React.createElement("div", { key: i, className: groupClass },
            React.createElement("div", { onClick: setActive(i), className: "c-neighbourhood__gtitle" },
                React.createElement("span", { className: "c-neighbourhood__caret" }),
                group.name),
            React.createElement("div", { className: "c-neighbourhood__gitems" }, group.items.map(renderItem))));
    };
    var renderGroups = function (props) {
        return props.neighbourhood.groups.map(function (it, i) {
            return renderGroup(it, i, props.neighbourhood.active);
        });
    };
    var filterClass = classnames_1.default([
        'c-neighbourhood__filter',
        {
            'c-neighbourhood__filter--active': props.neighbourhood.mobileActive,
        },
    ]);
    var currentFilterItem = props.neighbourhood.groups
        .reduce(function (all, it) {
        it.items.map(function (it2) { return all.push(it2); });
        return all;
    }, []).filter(function (it) {
        return it.type === props.neighbourhood.activeType;
    })[0].name;
    var filterMarkerClass = classnames_1.default(['c-marker', 'c-marker--inline', 'c-marker--active', "c-marker--" + NeighbourhoodSaga_1.getIconString(currentFilterItem.type),
    ]);
    return (React.createElement("div", { id: "place-neighbourhood", className: "l-pad-top--4 l-pad--4", style: bgStyle },
        React.createElement("div", { className: "l-container l-container--lr" },
            React.createElement("div", { className: "l-container__main" },
                React.createElement("div", { className: "t--darker", style: { marginBottom: 20 } },
                    React.createElement("h2", { className: "o-h1 o-h1--serif l-pad--2 u-preserve-cap o-h1--center-mobile", style: { margin: 0 } },
                        props.district,
                        " - ",
                        props.t.explore),
                    props.customExploreMarkdown ? (React.createElement("p", { className: "l-pad l-pad--2", style: { margin: 0, lineHeight: '20pt' } }, props.customExploreMarkdown)) : null))),
        React.createElement("div", { className: "c-neighbourhood" },
            React.createElement("div", { id: "neighbourhood-map", className: "c-neighbourhood__map" }),
            React.createElement("div", { className: filterClass },
                React.createElement("div", { onClick: props.toggleNeighbourMobileFilter, className: "c-neighbourhood__current" },
                    React.createElement("span", { className: "fa fa-filter" }),
                    React.createElement("span", { className: "u-bold" },
                        props.t.filter,
                        " : "),
                    React.createElement("span", { className: filterMarkerClass }),
                    currentFilterItem,
                    React.createElement("span", { className: "c-neighbourhood__caret" })),
                React.createElement("div", { className: "c-neighbourhood__groups" }, renderGroups(props))))));
};
